/*
 Created by qing 2020/1/22 4:01 下午
 */

export default {
  props: {
    showPropertiesHolder: {
      type: Object,
      default: () => ({})
    },
    chartPropertiesHolder: {
      type: Object,
      default: () => ({})
    },
    current: {
      type: Object,
      default: () => ({})
    },
    value: Object | null,
    showDataDrillDownList: Function
  },
  // data() {
  //   return {
  //     showHolder: this.showPropertiesHolder,
  //     chartHolder: this.chartPropertiesHolder,
  //     currentValue: this.current,
  //     dataValue: this.value
  //   }
  // }
}
